import { Component } from '@angular/core';
import { AppService } from '../app.service';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Device } from '../device';
import { CryptoService } from '../crypto.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Component({
  selector: 'app-add-user',
  standalone: false,
  templateUrl: './add-user.component.html',
  styleUrls: ['./add-user.component.css']
})

export class AddUserComponent {

  addUserForm: FormGroup;
  dev: Device | any;
  sign: any;
  apiKey: any;
    status: any;
   workspaceName:any;
  txt: any;

  constructor(public appService: AppService, public router: Router, private fb: FormBuilder, private cs: CryptoService, private http: HttpClient) {

    this.addUserForm = this.fb.group({
      name: ["", [Validators.required]],
      identification: ["", [Validators.required]],
      identificationType: 'UNIQUE_ID',
      routeType:"UI_SESSION"
    });
  }

  ngOnInit(): void {
  }


  async submit() {

 if (this.addUserForm.valid) {
  try {

      const wsJson = this.appService.get("xdbc.workspace");

      if (wsJson) {
        const ws = JSON.parse(wsJson);
        this.apiKey = ws.apiKey;
        this.workspaceName = ws.workspaceName;
      }

      const activationPayload = this.addUserForm.value;


      const signatureData = await this.appService.wssign(
        activationPayload,
        this.workspaceName
      );

      if (!signatureData) {
        throw new Error("Failed to sign activation payload");
      }

      const signature = new TextDecoder().decode(signatureData);

      const response = await this.appService.wsPostRequestWithHeaders(
        activationPayload,
        "auth/create-profile",
        this.apiKey,
        signature
      );

      if (response && response.status == "Success") {
        this.txt = response.message;
          this.appService.addSuccessMessage(this.txt);
          this.router.navigate(["/users"]);        
      } else {
        throw new Error(response?.message);
      }
    } catch (error: any) {
        console.error("Error in submitPrivateKey:", error);
        this.txt = "Activation failed: " + (error.message || "Unknown error");
        this.appService.addErrorMessage(
          "Failed to activate connector: " + (error.message || "Unknown error")
        );
    }
}

}

  cancel() {
    this.router.navigate(["/users"]);
  }

}
